<template>
  <div class="popover" @click="togglePopover">
    <div class="popover-label">
      {{ label }}
      <span class="down-caret" :class="{ 'open-caret': isOpen }"></span>
    </div>
    <div
      v-if="isOpen"
      class="popover-content"
      :class="{ open: isOpen }"
      @click="openPopover"
    >
      <slot></slot>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, onBeforeUnmount } from 'vue';

// Define component name
defineOptions({
  name: 'PopOver'
});

// Props
defineProps({
  label: String,
});

// Reactive data
const isOpen = ref(false);

// Methods
const togglePopover = (e) => {
  isOpen.value = !isOpen.value;
  stopDefaultBehavior(e);
};

const closePopover = () => {
  isOpen.value = false;
};

const openPopover = (e) => {
  isOpen.value = true;
  stopDefaultBehavior(e);
};

const stopDefaultBehavior = (e) => {
  e.preventDefault();
  e.stopPropagation();
};

// Lifecycle hooks
onMounted(() => {
  document.addEventListener("click", closePopover);
});

onBeforeUnmount(() => {
  document.removeEventListener("click", closePopover);
});
</script>

<style>
.popover {
  display: inline-block;
  position: relative;
  min-height: 40px;
}
.popover-label {
  padding: 10px 8px 8px 8px;
  font-size: 14px;
  color: #3a4145;
  cursor: pointer;
}
.popover-content {
  position: absolute;
  z-index: 1;
  max-height: 0;
  overflow: hidden;
  transition: all 0.25s linear;
  background-color: white;
  box-shadow: 0 0 1px rgba(0, 0, 0, 0.15);
  right: 0;
  margin-top: 9px;
}
.popover-content.open {
  max-height: 300px;
  height: auto;
  transition: all 0.25s linear;
}
.down-caret {
  width: 0;
  height: 0;
  border-style: solid;
  border-width: 5px 5px 0 5px;
  border-color: #3a4145 transparent transparent transparent;
  display: inline-block;
  margin-left: 5px;
  top: -1px;
  position: relative;
  transform: rotate(0deg);
  transition: all 0.25s ease-in;
}
.open-caret {
  transform: rotate(180deg);
  transition: all 0.25s ease-out;
}
</style>
